import React from "react";
import { Box, Typography } from "@mui/material";
import AddBrokerModal from "../../features/AddBrokerModal";
import SelectSensorModal from "../../features/SelectSensorModal";
import SensorCard from "../../components/sensorCard/SensorCard";
import { useColors } from "../../theme";
import { useSelection } from "../../services/localStorageContext";

const Dashboard = () => {
    const colors = useColors();
    const { selection } = useSelection();

    const hasSelection = selection && Object.keys(selection).length > 0;

    return (
        <div key={"Dashboard_div"}>
            {/* Modale zum Hinzufügen von Brokern und Auswählen von Sensoren */}
            {/* <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                paddingY={5}
            >
                <Box marginX={5}>
                    <AddBrokerModal />
                </Box>
                <Box marginX={5}>
                    <SelectSensorModal />
                </Box>
            </Box> */}

            {/* Sensorliste rendern */}
            {hasSelection ? (
                <div key={"selected-Sensors_div"}>
                    {Object.entries(selection).flatMap(([brokerName, sensors]) =>
                        sensors.map((sensorName) => (
                            <SensorCard
                                key={`${brokerName}-${sensorName}_Card`}
                                broker={brokerName}
                                sensor={sensorName}
                            />
                        ))
                    )}
                </div>
            ) : (
                <div key={"no-selected-Sensors_div"}>
                    <Typography variant="h4" color={colors.grey[100]} p={10} textAlign="center">
                        Keine Sensoren ausgewählt
                    </Typography>
                </div>
            )}
        </div>
    );
};

export default Dashboard;